interface DayDividerProps {
  date: string;
}

export default function DayDivider({ date }: DayDividerProps) {
  const getDayLabel = (): string => {
    const messageDate = new Date(date);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const msgDay = new Date(
      messageDate.getFullYear(),
      messageDate.getMonth(),
      messageDate.getDate(),
    );
    const diffTime = today.getTime() - msgDay.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7)
      return messageDate.toLocaleDateString('en-US', { weekday: 'long' });

    if (messageDate.getFullYear() === now.getFullYear()) {
      return messageDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
    }

    return messageDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: '2-digit',
    });
  };

  return (
    <div className="flex items-center justify-center py-2">
      <span className="inline-flex items-center gap-2 rounded-full border bg-gray-100 px-3 py-1 text-xs text-gray-500 shadow-sm">
        <span>🗓️</span>
        <span>{getDayLabel()}</span>
      </span>
    </div>
  );
}
